export default __webpack_public_path__ + "static/media/Astronaut-big.0d2e7691.png";